import { Phone, ArrowRight, Clock } from "lucide-react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { business, images } from "@/data/content";

export default function FinalCTA({ onQuote }) {
  return (
    <section className="relative py-16 lg:py-24 overflow-hidden navy-gradient" data-testid="final-cta-section">
      <img
        src={images.ripple}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover opacity-15"
      />
      <div className="absolute inset-0 hero-grain opacity-20" />
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="relative mx-auto max-w-4xl px-5 text-center"
      >
        <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-light text-white tracking-tight text-balance">
          Let’s Improve Your Water System
        </h2>
        <p className="mt-6 text-base sm:text-lg text-white/80 leading-relaxed max-w-2xl mx-auto">
          Speak with our local Sunshine Coast team about tank cleaning, water filtration, UV
          protection, water testing or complete water system maintenance.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            data-testid="final-quote-cta"
            onClick={onQuote}
            className="rounded-full bg-white hover:bg-pristine-aqua text-pristine-blue h-14 px-8 text-base font-semibold group transition-transform hover:scale-[1.03]"
          >
            Request a Quote
            <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
          </Button>
          <a href={business.phoneHref} data-testid="final-call-cta">
            <Button
              variant="outline"
              className="rounded-full border-2 border-white/40 bg-transparent text-white hover:bg-white/10 h-14 px-8 text-base font-semibold w-full"
            >
              <Phone className="mr-2 h-5 w-5" /> Call {business.phone}
            </Button>
          </a>
        </div>

        <p className="mt-8 inline-flex items-center gap-2 text-sm text-white/70">
          <Clock className="h-4 w-4" /> {business.hours}
        </p>
      </motion.div>
    </section>
  );
}
